const routes = {
  '/app/company-account-setup': {
    fetch: () =>
      import(
        /* webpackChunkName: 'company-account-route' */ 'app/company-account/asyncRoute'
      ).then(module => module.default),
  },
};

export default routes;
